/* eslint-disable no-undef */
import { useState, useEffect, useMemo, useRef } from 'react';
import s from './h5.style.module.scss';
import { captchaVerify } from './api';
import { useToast } from '@/stores/ToastContext';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

const RankingBoardMystery = (props) => {
  const { setShowCaptcha, toNext } = props;
  const showToast = useToast();
  const [showInfo, setShowInfo] = useState(false);
  const [token, setToken] = useState(null);
  const { t } = useTranslation();

  const onClose = () => {
    window?.nativeBridge && window.nativeBridge.callNativeFunction('goBack', null);
  };

  useEffect(() => {
    setShowInfo(true);
  }, []);

  const handleVerify = async (token) => {
    const res = await captchaVerify({ token });
    if (res?.success) {
      setShowCaptcha(false);
      toNext();
    } else {
      setShowCaptcha(false);
      showToast(t('DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_TITLE'));
    }
  };

  const handleError = (e) => {
    console.error('e===', e);
    setShowCaptcha(false);
    showToast(t('DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_TITLE'));
  };

  const captchaRef = useRef();

  const onLoad = () => {
    // console.log('captcha loaded');
    // captchaRef.current.execute();
  };

  if (!showInfo) return null;

  return createPortal(
    <>
      <div className={s.wrapper}>
        <div className={s.mask} />
        <div className={s.content}>
          <div className={s.closeBtn} onClick={() => setShowCaptcha(false)} />
          {showInfo && (
            <HCaptcha
              sitekey="11fa6f74-7622-4ef4-b5e0-1322dd261ce6"
              onLoad={onLoad}
              onVerify={handleVerify}
              ref={captchaRef}
              // size="invisible"
              onError={handleError}
              onExpire={handleError}
              onChalExpired={handleError}
              languageOverride="en"
            />
          )}
        </div>
      </div>
    </>,
    document.body
  );
};

export default RankingBoardMystery;
